import type { RegisteredComponent } from "@builder.io/sdk-react";
import { isEditing } from "@builder.io/sdk-react";

import { useLayoutData } from "~/routes/layout";

interface LmnAllowedContentProps {
  children?: React.ReactNode;
  attributes?: Record<string, unknown>;
}

/**
 * LmnAllowedContent — renders children only for LMN-allowed sessions.
 * LMN-allowed = no TPA afid (regular user) OR TPA afid present on the
 * lmnListAllowsTPA allow list.
 *
 * Ported from hec-composable:
 *   hec/builder/blocks/content-by-access/lmnAllowedContent.tsx
 * Workers data source: layout loader → useLayoutData().lmnAllowed
 */
const LmnAllowedContent = ({
  children,
  attributes,
}: LmnAllowedContentProps) => {
  const { lmnAllowed } = useLayoutData();
  // In Builder visual editor, always render children so authors can reach and
  // edit gated content regardless of the current session's LMN status.
  if (!isEditing() && !lmnAllowed) return null;
  return <div {...attributes}>{children}</div>;
};

export const LmnAllowedContentDefinition = {
  component: LmnAllowedContent,
  name: "LmnAllowedContent",
  noWrap: true,
  canHaveChildren: true,
  image: "https://unpkg.com/lucide-static@0.537.0/icons/clipboard-check.svg",
  inputs: [],
} satisfies RegisteredComponent;

export default LmnAllowedContent;
